import React, { Component } from 'react'
import { AutoSizer, InfiniteLoader, List } from 'react-virtualized'
import { Pane, Spinner, majorScale } from '@segment/react-ui-library'
import ShowHide from 'ui/ShowHide'
import moment from 'moment'
import getProp from '@f/get-prop'
import ListItem from './ListItem'
import TableHeader from './TableHeader'
import css from './Table.module.css'

class Table extends Component {
  constructor () {
    super()
    this.rowRenderer = this.rowRenderer.bind(this)
  }

  render () {
    return (
      <Pane className={css.table} display='flex' flexDirection='column'>
        <TableHeader />

        <ShowHide show={!this.props.users.length}>
          <Pane display='flex' justifyContent='center' marginTop={majorScale(3)}>
            <ShowHide show={this.props.searchRequest.didRequestFail}>
              No user found with email: <strong>{this.props.id}</strong>
            </ShowHide>

            <ShowHide show={!this.props.searchRequest.didRequestFail}>
              <Spinner />
            </ShowHide>
          </Pane>
        </ShowHide>

        <Pane className={css.loading} flex='1'>
          <InfiniteLoader
            loadMoreRows={() => this.props.fetchCustomers(this.props.next)}
            isRowLoaded={({ index }) => !!this.props.users[index]}
            rowCount={this.props.rowCount}>
            {({ onRowsRendered, registerChild }) => (
              <AutoSizer>
                {({ width, height }) => (
                  <List
                    ref={registerChild}
                    onRowsRendered={onRowsRendered}
                    rowRenderer={this.rowRenderer}
                    rowCount={this.props.rowCount}
                    height={height}
                    rowHeight={48}
                    width={width}
                  />
                )}
              </AutoSizer>
            )}
          </InfiniteLoader>
        </Pane>
      </Pane>
    )
  }

  rowRenderer ({ index, key, style }) {
    const user = this.props.users[index]
    if (!user) return

    const { segmentId, properties, metadata } = user
    const updatedAtTimestamp = new Date(getProp('updated_at', metadata))
    const updatedAt = moment(toLocalTime(updatedAtTimestamp)).fromNow()

    return (
      <ListItem
        to={`/${this.props.workspaceSlug}/customers/profiles/${user.segmentId}`}
        id={segmentId}
        name={properties.name}
        avatar={properties.avatar}
        updatedAt={updatedAt}
        key={key}
        style={style} />
    )
  }
}

function toLocalTime (date) {
  const timezone = moment.tz.guess()
  return moment(date).tz(timezone)
}

export default Table



// WEBPACK FOOTER //
// ./components/Customers/CustomersProfiles/Table.js